export const styles = {
  paper: {
    margin: "20px auto",
    padding: 20,
    maxWidth: 650
  },
  todoGrid: {
    marginTop: "10px"
  },
  paperMobile: {
    width: "100%",
    minHeight: "90vh",
    borderTopLeftRadius: 35,
    backgroundColor: "white"
  },
  headerText: {
    fontFamily: "'Oswald', sans-serif"
  },
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "baseline",
    justifyContent: "space-evenly",
    marginBottom: "80px"
  },
  image: { width: "100%" },
  grow: {
    flexGrow: 1
  },
  appBar: {
    top: "auto",
    bottom: 0
  },
  fabButton: {
    position: "absolute",
    zIndex: 1,
    top: -30,
    left: 0,
    right: 0,
    margin: "0 auto"
  },
  done: {
    textDecoration: "line-through",
    color: "gray",
    fontFamily: "'PT Sans', sans-serif"
  },
  toDo: {
    fontFamily: "'PT Sans', sans-serif"
  },
  greenDot: {
    height: 15,
    width: 15,
    backgroundColor: "#8AC926",
    borderRadius: "50%",
    display: "inline-block",
    marginRight: 10
  },
  redDot: {
    height: 15,
    width: 15,
    backgroundColor: "#FF8042",
    borderRadius: "50%",
    display: "inline-block",
    marginRight: 10
  },
  blueDot: {
    height: 15,
    width: 15,
    backgroundColor: "#6675D5",
    borderRadius: "50%",
    display: "inline-block",
    marginRight: 10
  },
  button: {
    width: "80%",
    margin: "25px auto"
  },
  textField: {
    marginLeft: "10%"
  },
  counterMobile: {
    fontFamily: "'PT Sans', sans-serif",
    color: "gray"
  },
  chart: {
    margin: "10px auto"
  },
  chartBlock: {
    margin: "30px auto",
    padding: 20,
    maxWidth: 600
  },
  chartBlockMobile: {
    margin: "0 auto",
    padding: 20,
    maxWidth: 600
  },
  percentage: {
    paddingTop: "150px",
    color: "#6675D5",
    fontSize: "50px",
    fontFamily: "'Oswald', sans-serif"
  },
  fabButtonWeb: {
    marginTop: "30px"
  },
  editIcon: {
    color: "lightgray"
  },
  deleteIcon: {
    color: "lightgray"
  },
  headerMobile: {
    position: "relative",
    height: "15vh",
    overflow: "hidden"
  },
  headerBg: {
    position: "absolute",
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundImage: "linear-gradient(#6675D5, #133FAC)",
    transform: "skewY(-6deg)",
    transformOrigin: "top left"
  }
};
